import React from 'react';

const StatCard = ({ title, value, icon: Icon, accent = 'blue', isLive = false }) => {
  const accents = {
    blue:   { icon: 'text-sky-300',    bg: 'bg-sky-400/12 ring-1 ring-sky-400/20' },
    green:  { icon: 'text-emerald-300', bg: 'bg-emerald-400/12 ring-1 ring-emerald-400/20' },
    purple: { icon: 'text-violet-300', bg: 'bg-violet-400/12 ring-1 ring-violet-400/20' },
    amber:  { icon: 'text-amber-300',  bg: 'bg-amber-400/12 ring-1 ring-amber-400/20' },
    indigo: { icon: 'text-indigo-300', bg: 'bg-indigo-400/12 ring-1 ring-indigo-400/20' },
    orange: { icon: 'text-orange-300', bg: 'bg-orange-400/12 ring-1 ring-orange-400/20' },
  };
  const tone = accents[accent] || accents.blue;

  return (
    <div className="stat-card flex flex-col gap-3">
      {/* top row: icon left, live badge right — no overlap possible */}
      <div className="flex items-center justify-between">
        <div className={`rounded-lg p-2.5 ${tone.bg}`}>
          <Icon className={`h-6 w-6 ${tone.icon}`} />
        </div>
        {isLive && (
          <div className="flex items-center gap-1.5">
            <div className="h-1.5 w-1.5 rounded-full bg-emerald-400 animate-pulse" />
            <span className="text-[10px] font-semibold tracking-wider text-emerald-400">Canlı</span>
          </div>
        )}
      </div>

      {/* label + number */}
      <div>
        <p className="text-sm font-medium text-slate-300 mb-1 leading-tight">{title}</p>
        <p className="text-3xl font-bold tracking-tight text-white">{value}</p>
      </div>
    </div>
  );
};

export default StatCard;
